import React from "react";
import "./Osadniki.scss";

import korytko4 from "../../assets/buildings/korytko4.png";
import korytko5 from "../../assets/buildings/korytko5.png";

function Osadniki() {
  return (
    <>
      <img className="korytko4" src={korytko4} alt="" />
      <img className="korytko5" src={korytko5} alt="" />
    </>
  );
}

export default Osadniki;
